import React, { useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import { FaFileArchive } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { AiFillEye } from "react-icons/ai";
import "./UserToUpdate.css";

const GrillaUserAlerts = ({ data }) => {
  const [alertUser, setAlertUser] = useState(data);
  const navigate = useNavigate();

  /*DAR DE BAJA A PERSONA HUMANA Y JURIDICA */
  const handleCasualty = async (e, identify, entityType) => {
    const id = identify;
    e.preventDefault();
    const endpoint =
      entityType === "Persona Humana"
        ? `${process.env.REACT_APP_CASUALTY_PERSON_API}`
        : `${process.env.REACT_APP_CASUALTY_COMPANY_API}`;
    try {
      const res = await axios.post(endpoint, {
        id,
        newStatus: "Baja",
      });

      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Correcto",
          text: res.data.message,
        });
        setAlertUser((prevAlertMessage) =>
          prevAlertMessage.filter((user) => user.identify !== identify)
        );
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.message,
      });
    }
  };

  /*EN BASE AL DNI Y LA RELACION LLEVA AL USUARIO A LA VISTA DE INFORMACION DE USUARIO*/
  const handleSearch = async (e, identify, relation) => {
    e.preventDefault();
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_SEARCH_USER_API}?id=${identify}&relation=${relation}`
      );
      if (res.data) {
        navigate("/informe", { state: res.data });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "No se encontró el usuario.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.response.data.message,
      });
    }
  };

  /*ACTUALIZAR POR NOSIS*/
  const handlerUpdate = async (e, identify, entityType) => {
    const id = identify;
    e.preventDefault();
    const endpoint =
      entityType === "Persona Humana"
        ? `${process.env.REACT_APP_UPDATE_USER_API}`
        : `${process.env.REACT_APP_UPDATE_COMPANY_API}`;
    try {
      const res = await axios.post(endpoint, {
        id,
      });

      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Correcto",
          text: res.data.message,
        });
        setAlertUser((prevAlertMessage) =>
          prevAlertMessage.filter((user) => user.identify !== identify)
        );
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.message,
      });
    }
  };

  /*PASAR PARAMENTROS DNI Y TIPO DE USUARIOS (LA ACTUAL ESTA MAL)*/
  const handleClick = (e, identify, relation) => {
    e.preventDefault();
    handleSearch(e, identify, relation);
  };

  const typeUser = (alertUser) => {
    if (alertUser.identify) {
      return alertUser.identify;
    }

    if (alertUser.identify) {
      return alertUser.identify;
    }
  };

  const typeRisk = (alertUser) => {
    if (alertUser.risk === "Riesgo alto") {
      return <p className="riskhigh">Riesgo Alto</p>;
    }

    if (alertUser.risk === "Riesgo medio") {
      return <p className="riskmid">Riesgo Medio</p>;
    }

    if (alertUser.risk === "Riesgo bajo") {
      return <p className="risklow">Riesgo Bajo</p>;
    }
  };

  return (
    <div className="boxtableUserAlert">
      <table className="tableUserAlerts">
        <thead>
          <tr>
            <th className="tableUserHeader">Riesgo</th>
            <th className="tableUserHeader">Usuario</th>
            <th className="tableUserHeader">Dni / Cuit</th>
            <th className="tableUserHeader">Relacion con la Mutual</th>
            <th className="tableDocumentHeader">Tipo de Usuario</th>
            <th className="tableUserHeader">Fecha de vencimiento del perfil</th>
            <th className="tableUserHeader">Actualizar</th>
            <th className="tableUserHeader">Inactivar</th>
            <th className="tableUserHeader">Perfil</th>
          </tr>
        </thead>
        <tbody>
          {alertUser.map((item, index) => {
            return (
              <tr key={index}>
                <td className="tableUserDataRisk">{typeRisk(item)}</td>
                <td className="tableUserData">{item.name}</td>
                <td className="tableUserData">{typeUser(item)}</td>
                <td className="tableUserData">{item.relation}</td>
                <td className="tableUserData">{item.entityType}</td>
                <td className="tableUserData">{item.expirestAt}</td>
                <td
                  className="tableUserData"
                  onClick={(e) =>
                    handlerUpdate(e, item.identify, item.entityType)
                  }
                >
                  <FaFileArchive className="iconGrilla" />
                </td>
                <td
                  className="tableUserData"
                  onClick={(e) =>
                    handleCasualty(e, item.identify, item.entityType)
                  }
                >
                  <MdDelete className="iconGrilla2" />
                </td>
                <td
                  className="tableUserData"
                  onClick={(e) => handleClick(e, item.identify, item.relation)}
                >
                  <AiFillEye className="iconGrilla2" />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default GrillaUserAlerts;
